import React, {useEffect, useState} from 'react'
import {useForm} from "react-hook-form";
import Card from "../../components/forms/Card";
import FormGroup from "../../components/forms/FormGroup";
import Input from "../../components/forms/FormEl";
import Button from "../../components/forms/Button";
import {Apis} from "../../util/data";
import convertDate from "../../util/convertDate";
import {format, isSameDay} from "date-fns";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import AsyncBlock from "../../components/forms/AsyncBlock";
import axios from "axios";
const CitaForm = ({value, onSubmit}) => {

  const {setValue, handleSubmit, reset} = useForm(
    {defaultValues: value}
  );

  const [dias, setDias] = useState([])
  const [consejeros, setConsejeros] = useState(null)
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedConsej, setSelectedConsej] = useState(null);
  const [selectedConsejPorConsejeria, setSelectedConsejPorConsejeria] = useState(null);
  const [selectedHora, setSelectedHora] = useState(null);
  const [loading,setLoading] = useState(false);
  const [loading2,setLoading2] = useState(false)
  const [loading3,setLoading3] = useState(false)
  const [horas, setHoras] = useState(null)

  const getDias = async () =>{
    setLoading(true)
    try {
      const {data} = await axios.get(Apis.PROD + '/horario-atencion/dias/' + value.idConsejeria )
      if (data !== undefined){
        setDias(data.map((dia)=>{ return convertDate(dia,"yyyy-MM-dd")}))
      }
      setLoading(false)
    } catch (error){
      setLoading(false)
      console.log(error)
    }
  }

  const getConsejeros = async (fecha) => {
    setLoading2(true)
    try {
      const body = {
        idConsejeria: value.idConsejeria,
        fecha: fecha
      }
      const {data} = await axios.post(Apis.PROD + '/horario-atencion/consejeros',body )
      if (data !== undefined){
        console.log('consej',data)
        setConsejeros(data)
      }
      setLoading2(false)
    } catch (error){
      setLoading2(false)
      console.log(error)
    }
  }

  const getHoras = async (fecha, idConsejero) => {
    setLoading3(true)
    try {
      const body = {
        idConsejeria: value.idConsejeria,
        idConsejero: idConsejero,
        fecha: fecha
      }
      console.log('horas',body)
      const {data} = await axios.post(Apis.PROD + '/horario-atencion/horas',body )
      if (data !== undefined){
        setHoras(data)
      }
      setLoading3(false)
    } catch (error){
      setLoading3(false)
      console.log(error)
    }
  }

  useEffect(() => {
    if (value && value.idConsejeria) {
      getDias()
      reset(value)
    }
  }, [value])

  useEffect(() => {
    if(selectedDate){
      setHoras(null)
      setSelectedConsej(null)
      setSelectedHora(null)
      getConsejeros(format(selectedDate,"yyyy-MM-dd"))
    }
  }, [selectedDate]);

  useEffect(() => {
    if(selectedConsej){
      setSelectedHora(null)
      getHoras(format(selectedDate,"yyyy-MM-dd"),selectedConsej)
    }
  }, [selectedConsej]);

  useEffect(() => {
    if(selectedHora !== null){
      if(selectedDate !== null )setValue("selectedFechaCita",format(selectedDate,"yyyy-MM-dd") + 'T' + selectedHora + ':00')
      else setValue("selectedFechaCita",null)
      setValue("selectedConsejeroConsejeriaId", selectedConsejPorConsejeria)
    }
  }, [selectedHora]);

  const isDayDisabled = (date) =>{
    const fechaCalendario = new Date(date);
    const diasDisponiblesParsed = dias.map(d => {
      return new Date(d+"T00:00:00-05:00");
    });
    return !diasDisponiblesParsed.some((enabledDate) => {
      return isSameDay(enabledDate,fechaCalendario);
    });
  }


  return (
    <form>
      <Card padding>
        <FormGroup>
          <div style={{display: "inline-flex", flexDirection: "column"}}>
            <label>Fecha de la cita</label>
            <AsyncBlock loading={loading}>
              <DatePicker
                selected={selectedDate}
                onChange={date =>
                  setSelectedDate(date)
                }
                filterDate={(date) => !isDayDisabled(date)}
                inline
              />
            </AsyncBlock>
          </div>
        </FormGroup>

        { consejeros &&
          <FormGroup>
            <div style={{display: "inline-flex", flexDirection: "column"}}>
              <label>Consejero</label>
              {consejeros.length > 0 ?
                <AsyncBlock loading={loading2}>
                  <div style={{display:"flex",flexDirection:"row"}}>
                    {consejeros.map(consejero =>
                      <div key={consejero.id} onClick={() => {
                        setSelectedConsej(consejero.id)
                        setSelectedConsejPorConsejeria(consejero.idConsejeroPorConsejeria)
                      }}
                           style={{display: "flex", flexDirection: "row", border: "solid",
                             borderWidth: "0.5px", alignItems: "center", padding: "8px", borderRadius: "15px",
                             marginRight: 5, cursor: "pointer", backgroundColor: consejero.id === selectedConsej ? "lightgray" : "white"}}>
                        <img style={{height: 60, width: 60, borderRadius: "15px"}} src={consejero.url} alt="Sin foto"/>
                        <div style={{marginLeft: 8}}>{consejero.nombre}</div>
                      </div>
                    )}
                  </div>
                </AsyncBlock> :
                <div>No hay consejeros disponibles</div>
              }
            </div>
          </FormGroup>
        }

        { horas &&
          <FormGroup>
            <div style={{display: "inline-flex", flexDirection: "column"}}>
              <label>Hora</label>
              {horas.length > 0 ?
                <AsyncBlock loading={loading3}>
                  <div>
                    {horas.map((hora,index) =>
                      <div key={index} onClick={() => {
                        setSelectedHora(hora)
                      }}
                           style={{display: "inline-flex", flexDirection: "row", border: "solid",
                             borderWidth: "0.5px", alignItems: "center", padding: "8px", borderRadius: "15px",
                             marginRight: 5, marginBottom: 5, cursor: "pointer", backgroundColor: hora === selectedHora ? "lightgray" : "white"}}>
                        <div style={{marginLeft: 8}}>{hora}</div>
                      </div>
                    )}
                  </div>
                </AsyncBlock> :
                <div>No hay horas disponibles</div>
              }
            </div>
          </FormGroup>
        }

      </Card>

      <Button variant={'primary'} onClick={handleSubmit(onSubmit)}>Guardar</Button>
    </form>
  )
}

export default CitaForm;
